<template>
  <div>
    <div v-if="[3].includes(logged_in_user.group_id)">
      <div v-for="phoenix_setting in filtered_phoenix_settings" :key="phoenix_setting.phoenix_setting_id" >
        <div v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.MULTICAST' && phoenix_setting.setting === 'ENABLED'">
          <div class="form-group row">
            <label class="col-sm-12 col-lg-2 col-form-label">Multicast</label>
            <div class="col-sm-12 col-lg-5">
              <select class="form-control" @change="editPhoenixSetting(phoenix_setting)" v-model="phoenix_setting.value">
                <option value="1">On</option>
                <option value="0">Off</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SMS' && phoenix_setting.setting === 'ENABLED'">
          <div class="form-group row">
            <label class="col-sm-12 col-lg-2 col-form-label">SMS</label>
            <div class="col-sm-12 col-lg-5">
              <select class="form-control" @change="editPhoenixSetting(phoenix_setting)" v-model="phoenix_setting.value">
                <option value="1">On</option>
                <option value="0">Off</option>
              </select>
            </div>
          </div>
        </div>
        <div v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SMS' && phoenix_setting.setting === 'MAX_PHONE_NUMBERS'">
          <div class="form-group row">
            <label class="col-sm-12 col-lg-2 col-form-label">SMS Max Phone Numbers</label>
            <div class="col-sm-12 col-lg-5">
              <input class="form-control" type="number" @change="editPhoenixSetting(phoenix_setting)" v-model="phoenix_setting.value">
            </div>
          </div>
        </div>
        <div v-if="phoenix_setting.domain === 'PHOENIX.FEATURE.SMS' && phoenix_setting.setting === 'PHONE_NUMBER'">
          <div class="form-group row">
            <label class="col-sm-12 col-lg-2 col-form-label">SMS Phone Number</label>
            <div class="col-sm-12 col-lg-5">
              <vue-tel-input :onlyCountries="['US']" :validCharactersOnly="true" @input="updatePhone" v-model="phoenix_setting.value"></vue-tel-input>
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr>
    <div class="form-group row">
      <label class="col-sm-12 col-lg-2 col-form-label">Built-In Command:</label>
      <div class="col-sm-12 col-lg-5">
        <div class="input-group">
          <select class="form-control" v-model="built_in_command">
            <option value="0">Select..</option>
            <option value="1" v-if="[2,3,4].includes(logged_in_user.group_id)">Sofia Status</option>
            <option value="2" v-if="[2,3,4].includes(logged_in_user.group_id)">Reload XML</option>
            <option value="7" v-if="[2,3,4].includes(logged_in_user.group_id)">Reload Mod Sofia</option>
            <option value="3" v-if="[2,3,4].includes(logged_in_user.group_id)">Sofia Status Profile Internal Reg</option>
            <option value="4" v-if="[2,3,4].includes(logged_in_user.group_id)">Sofia Status Profile Internal Reg (Mini)</option>
            <option value="5">Show Calls</option>
            <option value="8">Show Calls (Mini)</option>
            <option value="6">Stop All Calls</option>
          </select>
          <span class="input-group-btn">
            <button class="btn btn-hub-primary" type="button" @click="executeBuiltInCommand()">Execute</button>
          </span>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <pre class="command-result">{{ command_result }}</pre>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data: function () {
    return {
      built_in_command: '0',
      typed_command: ''
    }
  },
  computed: {
    ...mapGetters({
      command_result: 'commandResult',
      logged_in_user: 'loggedInUser'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', false)
  },
  methods: {
    executeBuiltInCommand () {
      this.$store.dispatch('executeCommand', this.built_in_command)
    }
  }
}
</script>

<style scoped>
  .command-result {
    background: black;
    color: white;
    -ms-word-wrap: break-word;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-wrap;
  }
</style>
